<div class="page">
    <div class="title">
        <button class="buttonBack" (click)="irAUrlAnterior()"><mat-icon>arrow_back</mat-icon></button>
        <div class="titleValue">{{ "cookiesPolicy.title" | transloco }}</div>
        <div class="line"></div>
    </div>

    <div class="content">
        <h3>{{ "cookiesPolicy.intro.title" | transloco }}</h3>
        <p>{{ "cookiesPolicy.intro.p1" | transloco }}</p>
        <p>{{ "cookiesPolicy.intro.p2" | transloco }}</p>
        <p>{{ "cookiesPolicy.intro.p3" | transloco }}</p>
        <h3>{{ "cookiesPolicy.cookiesTypesAndPurposes.title" | transloco }}</h3>
        <p>{{ "cookiesPolicy.cookiesTypesAndPurposes.p1" | transloco }}</p>
        <ul>
            <li *ngFor="let item of ('cookiesPolicy.cookiesTypesAndPurposes.durationTypes' | transloco)">{{item}}</li>
        </ul>
        <p>{{ "cookiesPolicy.cookiesTypesAndPurposes.p2" | transloco }}</p>
        <ul>
            <li *ngFor="let item of ('cookiesPolicy.cookiesTypesAndPurposes.pruposeTypes' | transloco)">{{item}}</li>
        </ul>
        <p>{{ "cookiesPolicy.cookiesTypesAndPurposes.p3" | transloco }}</p>
        <ul>
            <li *ngFor="let item of ('cookiesPolicy.cookiesTypesAndPurposes.useCases' | transloco)">{{item}}</li>
        </ul>
        <h3>{{ "cookiesPolicy.howToDisableCookies.title" | transloco }}</h3>
        <p>{{ "cookiesPolicy.howToDisableCookies.p1" | transloco }}</p>
        <p>{{ "cookiesPolicy.howToDisableCookies.p2" | transloco }}</p>
        <ul>
            <li><a href="https://support.google.com/chrome/answer/95647?hl=es&hlrm=en">Google Chrome</a></li>
            <li><a href="https://support.mozilla.org/es/kb/cookies-informacion-que-los-sitios-web-guardan-en-?redirectlocale=en-US&redirectslug=Cookies">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/es-es/HT201265">Apple Safari</a></li>
            <li><a href="https://support.microsoft.com/es-es/windows/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d">Microsoft Edge</a></li>
        </ul>
        <h3>{{ "cookiesPolicy.disablingCookies.title" | transloco }}</h3>
        <p>{{ "cookiesPolicy.disablingCookies.p1" | transloco }}</p>
        <h3>{{ "cookiesPolicy.changes.title" | transloco }}</h3>
        <p>{{ "cookiesPolicy.changes.p1" | transloco }}</p>
    </div>
</div>